@if(!loaded){
<p-skeleton width="22rem" height="13rem" />
}
<div [ngClass]="loaded ? 'block' : 'hidden'">
  <vg-player
    (onPlayerReady)="onPlayerReady($event)"
    (mouseover)="play_video()"
    (mouseleave)="pause_video()"
    (mouseenter)="show_controls = true"
    (mouseleft)="show_controls = false"
  >
    <vg-buffering
      vgFor="{{ id }}"
      (onUpdateBuffer)="(!is_loaded_metadata)"
    ></vg-buffering>
    @if (required_additional_options) {
    <span class="options" *ngIf="is_loaded_metadata">
      <span class="duration">{{ moment_start_time }}</span>
      <span class="download cursor-pointer" (click)="download(video_data)"
        ><i
          style="font-size: 1.5rem"
          [ngClass]="
            commonservice.downloading[this.id]?.value
              ? 'pi pi-spinner pi-spin pointer-events-none'
              : 'pi pi-download'
          "
        ></i
      ></span>
    </span>
    }
    <vg-controls *ngIf="required_additional_options">
      <vg-play-pause></vg-play-pause>
      <vg-mute></vg-mute>
      <vg-scrub-bar (mousemove)="updateHoveredTime($event)">
        <ng-container>
          <vg-scrub-bar-current-time
            [vgSlider]="true"
          ></vg-scrub-bar-current-time>
          <div
            *ngFor="let chapter of chapters; let i = index"
            class="chapter"
            [style.width.%]="chapter.width"
            (mouseenter)="chapterHover(i)"
            (mouseleave)="chapterLeave()"
            (click)="seekToChapter($event, chapter)"
            [ngStyle]="{
            'background-color': getChapterColor(chapter.startTime),
            'border-right': '2px solid gray',
          }"
          >
            <div
              class="chapter-container"
              *ngIf="hoveredChapterIndex === i"
              [style.left]="calculateChapterContainerLeft(hoveredPosition)"
            >
              <img
                class="chapter-img"
                [src]="getCapturedFrame(hoveredTimeInSeconds)"
              />
              <div class="chapter-timer">{{ hoveredTime }}</div>
            </div>
          </div>
        </ng-container>
        <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
      </vg-scrub-bar>
    </vg-controls>
    @if(videolibrary){
    <video
      #media
      [vgMedia]="$any(media)"
      [id]="id"
      preload="auto"
      crossorigin
      width="350"
      height="200"
    >
      <source [src]="video_url" type="video/mp4" />
    </video>
    }@else {
    <video
      #media
      [vgMedia]="$any(media)"
      [id]="id"
      preload="auto"
      [poster]="poster_image"
      crossorigin
      width="350"
      height="200"
    >
      <source [src]="video_url" type="video/mp4" />
    </video>
    }
  </vg-player>
</div>

@if(sprite_from_db){
<app-sprite-sheet-generator
  [spriteSheetUrl]="get_small_player_sprite_sheet()"
  (framesReady)="generateVideoThumbnailEvent($event)"
></app-sprite-sheet-generator>
}
